var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-graph-wrapper" },
    [
      _c(
        "v-container",
        { staticClass: "pa-0" },
        [
          _c(
            "v-row",
            {
              staticClass: "mx-n4",
              attrs: { "no-gutters": "", align: "center" }
            },
            _vm._l(_vm.zmluvy, function(zmluva, index) {
              return _c(
                "v-col",
                {
                  key: index,
                  staticClass: "px-4",
                  attrs: { xl: "3", lg: "3", md: "3" }
                },
                [
                  _c(
                    "v-card",
                    { attrs: { elevation: "0" } },
                    [
                      _c("p", { staticClass: "label" }, [
                        _vm._v(_vm._s(zmluva.label))
                      ]),
                      _c("p", { staticClass: "number" }, [
                        _vm._v(_vm._s(zmluva.pocet))
                      ]),
                      _c("v-img", {
                        attrs: {
                          contain: "",
                          src: require("../../assets/img/graf.png")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }